'use strict';

class Utils {
	/**
	 * checks if link is external
	 * */
	static linkIsExternal(linkElement) {
		return (linkElement.host !== window.location.host);
	}


	/**
	 * Set event listeners for all internal links to use history api
	 **/
	static ajaxify($links) {
		$links.each((i, el) => {
			if (!Utils.linkIsExternal(el)) {
				$(el).on('click', (evt) => {
					evt.preventDefault();
					History.pushState(null, '', $(evt.currentTarget).attr("href"));
				});
			}
		});
	}

	static retrieveGetParams() {
		let uriString = location.search.substring(1);
		if(uriString.length == 0){
			return {};
		}

		try {
			return JSON.parse('{"' + decodeURI(uriString).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}');
		} catch(e){
			return {};
		}
	}

	static isInIframe(){
		try {
			return window.self !== window.top;
		} catch (e) {
			return true;
		}
	}
}
